'use client';

import React, { useRef, useState } from 'react';
import { CSSProperties } from 'react';
import * as S from './styles';
import { useTheme } from 'styled-components';
import { Resenha } from '@/types/resenha';
import { Separator } from '@/components/atoms/Separator';
import ResenhaComentario from '@/components/molecules/ResenhaComentario';
import { calculaTempoPassado } from '@/utils/calculaTempoPassado';
import AlertDialog from '@/components/molecules/AlertDialog';
import useResenhaHook from '@/hooks/useResenhaHook';
import { useHomeData } from '@/hooks/useHomeData';
import { Card } from '@/components/atoms/Card';
import Text from '@/components/atoms/Text';
import { useSession } from 'next-auth/react';

export type ListagemResenhasComentarioProps = {
  $nomeFicha: string;
  $dados: Resenha[];
  style?: CSSProperties;
  contentContainerStyle?: CSSProperties;
};

export default function ListagemResenhasComentario(
  props: ListagemResenhasComentarioProps,
) {
  const { $nomeFicha, $dados, style, contentContainerStyle } = props;

  const theme = useTheme();
  const { curtirResenha, reportarResenha } = useResenhaHook();
  const { tiposDenunciaResenha } = useHomeData();
  const { status } = useSession();

  const [modalDenunciarVisivel, setModalDenunciarVisivel] = useState(false);
  const [motivoSelecionado, setMotivoSelecionado] = useState<string | null>();

  const resenhaRef = useRef<string | null>();

  function abrirModalDenuncia(id: string) {
    resenhaRef.current = id;
    setModalDenunciarVisivel(true);
  }

  function cancelarReportarResenha() {
    resenhaRef.current = null;
    setMotivoSelecionado(null);
    setModalDenunciarVisivel(false);
  }

  function selecionarMotivo(id: string) {
    setMotivoSelecionado(id);
    const element = document.getElementById('alertDialogContainer');
    if (element == null) return;
    element.scrollTop = element?.scrollHeight;
  }

  function confirmarReportarResenha() {
    if (resenhaRef.current != null && motivoSelecionado != null) {
      reportarResenha({
        usuarioTituloID: resenhaRef.current,
        tipoReportarResenhaID: motivoSelecionado,
      });
    }

    cancelarReportarResenha();
  }

  return (
    <S.Container style={style}>
      {$dados?.map((resenha, index) => (
        <div key={resenha.usuarioTituloID} style={contentContainerStyle}>
          <ResenhaComentario
            $nomeFicha={$nomeFicha}
            $id={resenha.usuarioTituloID}
            $nome={resenha.usuario?.nome}
            $imagemPerfil={resenha.usuario?.perfilArquivo?.urlx1}
            $comentario={resenha.comentario}
            $nota={resenha.avaliacao}
            $qtdCurtidas={resenha.qtdChippus}
            $timeStamp={calculaTempoPassado(resenha.dataAvaliacao)}
            $curtida={resenha.chippadoPorMim}
            $onClickCurtir={curtirResenha}
            $onClickDenunciar={abrirModalDenuncia}
            usuarioEstaLogado={status === 'authenticated'}
          />
          {index < $dados.length - 1 ? (
            <Separator
              style={{
                marginTop: theme.spacing[6],
                marginBottom: theme.spacing[6],
              }}
              $block
              $orientation="horizontal"
            />
          ) : null}
        </div>
      ))}
      <AlertDialog
        $size={2}
        $visivel={modalDenunciarVisivel}
        $titulo="Denunciar resenha"
        style={{ maxHeight: '70%' }}
        $descricao=""
        $Slot={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: theme.spacing[5],
            }}
          >
            {tiposDenunciaResenha?.map((item, index) => (
              <button
                id={'botaoEnviar' + index}
                key={'botao denunciar' + item.tipoReportarResenhaID}
                style={{ background: 'none' }}
                onClick={() => selecionarMotivo(item.tipoReportarResenhaID)}
              >
                <Card
                  $size={3}
                  $insetContent={false}
                  $interactive={true}
                  $variant={
                    item.tipoReportarResenhaID === motivoSelecionado
                      ? 'classic'
                      : 'ghost'
                  }
                  key={'card tipo denunciar' + item.tipoReportarResenhaID}
                  style={{
                    flexDirection: 'column',
                  }}
                >
                  <Text
                    $size={3}
                    $color="neutral"
                    $weight="semibold"
                    $align="center"
                    $highContrast
                    $text={item?.nome}
                  />
                  <Text
                    $size={2}
                    $color="neutral"
                    $weight="regular"
                    $align="center"
                    $highContrast
                    $text={item?.descricao}
                  />
                </Card>
              </button>
            ))}
          </div>
        }
        $textoBotaoCancelar="Cancelar"
        $textoBotaoAcao="Confirmar"
        $cancelarBotaoFuncao={cancelarReportarResenha}
        $acaoBotaoFuncao={confirmarReportarResenha}
      />
    </S.Container>
  );
}
